/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import "react-toastify/dist/ReactToastify.css";

import {
  BrokeragePricing,
  BrokingBannerCta,
  BrokingFaqs,
  GetStartedCta,
  HeroBanner,
  NewFooter,
  ProductSlider,
  SegmentAnalytics,
  WhyWealthyBroking
} from "components";
import React, {useEffect} from "react";

import GlobalStyle from "static/next/css/PartnerGlobalStyle";
import Head from "next/head";
import PropTypes from "prop-types";
import {ToastContainer} from "react-toastify";
import {WealthyEnv} from "helpers";
import {brokingSchema} from "nxtconstants";
import {getPartnerName} from "api";
import {triggerToast} from "helpers";

const propTypes = {
  productName: PropTypes.object,
  rCode: PropTypes.string,
  resetPin: PropTypes.bool
};

const defaultProps = {
  rCode: ""
};

const BrokingLanding = ({
  rCode,
  partnerName,
  resetPin
}) => {
  useEffect(() => {
    if (partnerName?.message) {
      triggerToast(partnerName?.message, "error");
    }
  }, []);

  return (
    <>
      <Head>
        <title>Wealthy Broking - Online stocks trading, lowest brokerage, free demat account</title>
        <link href={`${WealthyEnv.URL}/broking`} rel="canonical" />
        <link href="https://i.wlycdn.com/wealthy-home-page/new-fav-icon.png" rel="icon" />
        <link href="https://fonts.googleapis.com/css2?family=Marcellus&display=swap" rel="stylesheet" />
        <meta content="Wealthy broking - Start online trading with lowest brokerage charges in India. Open free demat account with zero AMC." name="description" />
        <meta content="Wealthy Broking - Online stocks trading, lowest brokerage, free demat account" name="title" />
        <script
          dangerouslySetInnerHTML={{__html: JSON.stringify(brokingSchema)}}
          type="application/ld+json"
        />
      </Head>
      <SegmentAnalytics />
      <GlobalStyle />
      <ToastContainer />
      <HeroBanner
        partnerData={partnerName}
        rCode={rCode}
        resetPin={resetPin}
      />
      {/* <BrokeragePricing
        partnerData={partnerName}
        rCode={rCode}
      /> */}
      <WhyWealthyBroking
        partnerData={partnerName}
      />
      <GetStartedCta
        partnerData={partnerName}
        rCode={rCode}
      />
      <ProductSlider />
      <BrokingFaqs />
      <BrokingBannerCta rCode={rCode} />
      <NewFooter />
    </>
  );
};

export async function getServerSideProps ({req}) {
  let partnerName = {};
  let rCode = req?.query?.rCode ?? req?.query?.rcode;
  let resetPin = req?.query?.pinResetSuccessfully;
  resetPin = typeof(resetPin) === "string" && true;
  if (rCode !== undefined && rCode !== "") {
    try {
      partnerName = await getPartnerName(rCode);
      partnerName = partnerName?.data;
    } catch (err) {
      partnerName = err?.response?.data;
    }
  } else {
    rCode = "";
  }

  return {
    props: {
      rCode,
      partnerName,
      resetPin
    }
  };
}

BrokingLanding.propTypes = propTypes;
BrokingLanding.defaultProps = defaultProps;

export default BrokingLanding;
